import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IUserAuthenticationTokens } from "../types";

interface IUserResetPasswordMutationParameters {
    uuid: string;
    token: string;
    password: string;
}

type IUserResetPasswordMutationResult = IUserAuthenticationTokens;

export const userResetPasswordMutation: IApiMutationFunction<IUserResetPasswordMutationParameters> = ({
    uuid,
    ...data
}) => {
    return {
        method: "PUT",
        url: `users/${uuid}/reset-password`,
        data,
    };
};

export const useUserResetPasswordMutation = createApiMutationHook<
    IUserResetPasswordMutationParameters,
    IUserResetPasswordMutationResult
>(userResetPasswordMutation);
